import React from 'react'
import { Row, Col } from 'react-bootstrap';
import BlackLogo from '../Header/Img/Black-Logo.png';
import WhiteLogo from '../Header/Img/White-Logo.png';
import LinearProgress from '@mui/material/LinearProgress';

export default function Loading() {
    // switch logo white and black based on theme
    const theme = document.documentElement.getAttribute('data-theme');
    const logo = theme === 'dark' ? WhiteLogo : BlackLogo;
    return (
        <Col xl={12} className='text-center min-vh-100 d-flex justify-content-center align-items-center'>
            <Row>
                <article className='mb-5'>
                    <img src={logo} height={150} alt='Loading' />
                </article>
                <article className='w-100'>
                    <LinearProgress />
                </article>
            </Row>
        </Col>
    );
}
